/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { Link, Typography } from "@mui/material";
import UIConstants from "../../../UIConstants";
import { translationKeys, useTranslation } from "../../Internationalisierung/i18nBasis";
import "./LANFooter.scss";

export default function LANFooter() {
    const { t } = useTranslation();
    return (
        <Typography className="lan-lanfooter" variant="body2">
            <Link href={UIConstants.impressumUrl} target="_blank" underline="hover" aria-label={t(translationKeys.lanFooter.impressum)}>{t(translationKeys.lanFooter.impressum)}</Link>{" | "}
            <Link href={UIConstants.agbUrl} target="_blank" underline="hover" aria-label={t(translationKeys.lanFooter.agb)}>{t(translationKeys.lanFooter.agb)}</Link>{" | "}
            <Link href={UIConstants.datenschutzUrl} target="_blank" underline="hover" aria-label={t(translationKeys.lanFooter.datenschutz)}>{t(translationKeys.lanFooter.datenschutz)}</Link>{" | "}
            <Link href={UIConstants.homepageUrl} target="_blank" underline="hover" aria-label={t(translationKeys.lanFooter.homepage)}>{t(translationKeys.lanFooter.homepage)}</Link>
        </Typography>
    );
}